<template>
  <div id="app">
    <a-locale-provider :locale="locale">
      <m-default-layout v-if="isLogin" />
      <m-sidebar-layout v-else />
    </a-locale-provider>
  </div>
</template>

<script>
import MDefaultLayout from "@/components/common/default-layout.vue";
import MSidebarLayout from "@/components/common/sidebar-layout.vue";
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';

export default {
  name: "App",
  data() {
    return {
      customer_id: 0,
      locale: zhCN,
    };
  },
  computed: {
    isLogin() {
      return this.$route.name === "auth.login";
    }
  },
  components: {
    MDefaultLayout,
    MSidebarLayout
  }
};
</script>

<style lang="scss" scoped>
#app {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue